/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { TwoDSubstanceConcentration } from "./TwoDSubstanceConcentration";
import {
  TwoDSubstanceConcentrationFromJSON,
  TwoDSubstanceConcentrationFromJSONTyped,
  TwoDSubstanceConcentrationToJSON,
  TwoDSubstanceConcentrationToJSONTyped,
} from "./TwoDSubstanceConcentration";

/**
 *
 * @export
 * @interface PaginatedTwoDSubstanceConcentrationList
 */
export interface PaginatedTwoDSubstanceConcentrationList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<TwoDSubstanceConcentration>;
}

/**
 * Check if a given object implements the PaginatedTwoDSubstanceConcentrationList interface.
 */
export function instanceOfPaginatedTwoDSubstanceConcentrationList(
  value: object
): value is PaginatedTwoDSubstanceConcentrationList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedTwoDSubstanceConcentrationListFromJSON(
  json: any
): PaginatedTwoDSubstanceConcentrationList {
  return PaginatedTwoDSubstanceConcentrationListFromJSONTyped(json, false);
}

export function PaginatedTwoDSubstanceConcentrationListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedTwoDSubstanceConcentrationList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(TwoDSubstanceConcentrationFromJSON),
  };
}

export function PaginatedTwoDSubstanceConcentrationListToJSON(
  json: any
): PaginatedTwoDSubstanceConcentrationList {
  return PaginatedTwoDSubstanceConcentrationListToJSONTyped(json, false);
}

export function PaginatedTwoDSubstanceConcentrationListToJSONTyped(
  value?: PaginatedTwoDSubstanceConcentrationList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(TwoDSubstanceConcentrationToJSON),
  };
}
